module.exports = __webpack_public_path__ + "static/media/no.0c98c480.svg";